import React from 'react'
import PropTypes from 'prop-types'

const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
    green: 'bg-green-50 text-green-600 dark:bg-green-900/30 dark:text-green-400',
    red: 'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400',
    yellow: 'bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400',
    purple: 'bg-purple-50 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
    pink: 'bg-pink-50 text-pink-600 dark:bg-pink-900/30 dark:text-pink-400',
    indigo: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400',
    gray: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
    orange: 'bg-orange-50 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
    teal: 'bg-teal-50 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400',
}

const sizeClasses = {
    xs: 'text-xs px-2.5 py-1 font-semibold',
    sm: 'text-sm px-3 py-1.5 font-semibold',
    md: 'text-base px-4 py-2 font-semibold',
    lg: 'text-lg px-5 py-2.5 font-semibold',
    xl: 'text-xl px-6 py-3 font-semibold',
}

const Badge = ({
    children,
    color = 'blue',
    size = 'sm',
    className = '',
    ...props
}) => {
    const colorClass = colorClasses[color] || colorClasses.blue
    const sizeClass = sizeClasses[size] || sizeClasses.sm

    return (
        <span
            className={`
        inline-flex items-center justify-center
        truncate    
        rounded-full
        border
        ${colorClass}
        ${sizeClass}
        ${className}
      `}
            {...props}
        >
            {children}
        </span>
    )
}

Badge.propTypes = {
    children: PropTypes.node.isRequired,
    color: PropTypes.oneOf(Object.keys(colorClasses)),
    size: PropTypes.oneOf(Object.keys(sizeClasses)),
    className: PropTypes.string,
}

export default Badge
